import { Typography, Button } from "../../components"
import "./styles.css";

export default function GidsvoorProfessionals(props) {
    return (
        <div className="container">
            <iframe
                title="Gids voor professionals - NOLIA BabyFeeding"
                src="https://app.enormail.eu/subscribe/e036fe871d040ee3bb6e196e52125874"
                style={{
                width: "100%",
                height: "100vh",
                border: "none"
                }}
                allow="fullscreen; payment"
            ></iframe>
        </div>
    )
}